import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";

Vue.config.productionTip = false;

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

// app.js
import "@/scss/custom.scss";
import Icon from "vue-awesome/components/Icon";

// globally (in your main .js file)
Vue.component("v-icon", Icon);

import "vue-awesome/icons/heart";
import "vue-awesome/icons/brands/youtube";
import "vue-awesome/icons/external-link-alt";
import "vue-awesome/icons/images";
import "vue-awesome/icons/list";
import "vue-awesome/icons/exclamation-triangle";

// Global components.
import ObjectPrint from "@/components/ObjectPrint.vue";
Vue.component("ObjectPrint", ObjectPrint);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
